<template>
    <div>
        <multiselect v-model="value"  placeholder="Search a tag" label="name" track-by="id" :options="list" :multiple="true" :taggable="true" @input="selectTag"></multiselect>
        <div class="categoriesList">
            <input v-for="category in value" v-bind:key="category.id" type="hidden" :name="name_input" :value="category.id">
        </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
    components: {
        Multiselect
    },
    mounted() {
        this.list  = this.categories
        this.value = this.course_categories
    },
    data () {
        return {
            value: [],
            list: []
        }
    },
    methods: {
        selectTag (tagList) {
            this.value = tagList
        }
    },
    props: {
        categories: {
            type: Array,
            required: true
        },
        name_input:{
            type: String,
            required: true
        },
        course_categories:{
            type: Array,
            required : true
        }
    }
}
</script>

<style>
  /*.custom-actions button.ui.button {
    padding: 8px 8px;
  }
  .custom-actions button.ui.button > i.icon {
    margin: auto !important;
  }*/
</style>
